import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useState } from "react";
import { formatarNomeUpper } from "../../utils/formatadores"

const Navbar = () => {

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate("/login");
    }
  };

  return (

  <header>

    {/* USUÁRIO LOGADO */}
    <div className="topbar">

      <div className="usuario-logado">
        👤 {formatarNomeUpper(user?.nome)} | {user?.profissao} - ({user?.email})
        <br />
        <p style={{textAlign:"right"}}>
        
        </p>
      </div>

      <li className="logout">
          <button onClick={handleLogout}>
            Sair
          </button>
        </li>

    </div>

    {/* NAVBAR */}

    <nav className="navbar">

      {/* LOGO */}
      <div className="logo">
        <h2>
          <Link to="/">
            <img
              src="/logo_aplicacao.png"
              style={{ width:"100px" }}
              alt="Logo do sistema"
            />
          </Link>
        </h2>
      </div>

      {/* BOTÃO MOBILE */}
      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </button>

      <ul className={`menu ${menuOpen ? "open" : ""}`}>

        <li>
          Home
          <ul className="dropdown">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/home/equipe">Equipe</Link></li>
            <li><Link to="/home/parceiros">Parceiros</Link></li>
            <li><Link to="/home/historia">Nossa história</Link></li>
          </ul>
        </li>

        <li>
          Recepção
          <ul className="dropdown">
            <li><Link to="/recepcao/recepcao">Recepção</Link></li>
          </ul>
        </li>

        <li>
          Cliente
          <ul className="dropdown">
            <li><Link to="/cliente/cadastro">Cadastrar cliente</Link></li>
            <li><Link to="/cliente/clientes">Clientes</Link></li>
          </ul>
        </li>

        <li>
          Atendimento
          <ul className="dropdown">
            <li><Link to="/atendimento/fila-atendimento">Atender</Link></li>
          {/*<li><Link to="/atendimento/trabalhista">Trabalhista</Link></li>
            <li><Link to="/atendimento/previdenciario">Previdenciário</Link></li>
            <li><Link to="/atendimento/civel">Cível</Link></li>
            <li><Link to="/atendimento/criminal">Criminal</Link></li>  */}
            <li><Link to="/atendimento/pendentes">Pendentes</Link></li>
            <li><Link to="/atendimento/outros">Outros</Link></li>
            <li><Link to="/atendimento/realizados">Realizados</Link></li>
          </ul>
        </li>

        <li>
          Processos
          <ul className="dropdown">
            <li><Link to="/processos/cadastrar">Cadastrar processo</Link></li>
            <li><Link to="/processos">Consultar processos</Link></li>
            <li><Link to="/processos/peticionar">Peticionar</Link></li>
            {/*<li><Link to="/processos/andamento">Andamento</Link></li>
            <li><Link to="/processos/conhecimento">Fase de conhecimento</Link></li>
            <li><Link to="/processos/execucao">Execução</Link></li>
            <li><Link to="/processos/conclusos">Conclusos</Link></li>*/}
            <li><Link to="/processos/dashboard">Dashboard</Link></li>
            <li><Link to="/editor-peticao">Editor Petição</Link></li>
          </ul>
        </li>

        <li>
          Agenda
          <ul className="dropdown">
            <li><Link to="/agenda/lancar">Novo Compromisso</Link></li>
            <li><Link to="/agenda/consultar">Agendados</Link></li>
          </ul>
        </li>

        {(user?.isAdmin) && (
        <li>
          Financeiro
          <ul className="dropdown">
            <li><Link to="/financeiro/lancar">Lançar</Link></li>
            <li><Link to="/financeiro/financeiro">Financeiro</Link></li>
            <li><Link to="/financeiro/dashboardfinanceiro">DashBoard Financeiro</Link></li>
            <li><Link to="/comprovante/validarcomprovante/:id">Validar Comprovante</Link></li>
          </ul>
        </li>
        )}
        
        {(user?.isAdmin || user?.isTI) && (
          <li>
            Administrativo
            <ul className="dropdown">
              <li><Link to="/administrativo/cadastro-usuario">Cadastrar usuário</Link></li>
              <li><Link to="/administrativo/gerenciamento-usuarios">Gerenciamento de usuários</Link></li>
              <li><Link to="/administrativo/logins">Gerenciamento de Logins</Link></li>
              <li><Link to="/administrativo/produtividade">{/* <FaChartLine /> */} Produtividade e Auditoria</Link></li>
              <li><Link to="/administrativo/documentos">Contratos e Documentos</Link></li>
            </ul>
          </li>
        )}

        <li>
          Ajuda
          <ul className="dropdown">
            <li><Link to="/ajuda/pje">Painel PJe</Link></li>
            <li><Link to="/ajuda/oab">Painel OAB</Link></li>
          </ul>
        </li>

      </ul>

    </nav>
    </header>
  );
};

export default Navbar;
